'use client';

import { CustomError } from '@benzinga/templates';
import PageLayout from './_components/PageLayout';

export default function Error({ error: _error }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <PageLayout pageProps={{ isSSR: true }}>
      <CustomError statusCode={500} />
    </PageLayout>
  );
}
